export { default } from './GlobalLayout'
